module.exports = __webpack_public_path__ + "media/images/icons/credit_card/amex-c03130085fae7f4df7f4bf98cb2648be.png";